/*
 * environment (utils)
 */
import { capitalizeFirstLetter } from "./format.utils"

export const Platform = process.env["PLATFORM"] || "unknown"

export const NxAppName = process.env["NX_TASK_TARGET_PROJECT"] || "unknown"

export const Title = capitalizeFirstLetter(
	process.env["NEXT_PUBLIC_TITLE"] || process.env["APP_TITLE"] || "unknown",
	true,
)

export const NextApp = process.env["NEXT_PUBLIC_CLIENT_ID"] || "unknown"
export const AppName = (process.env["APP_TITLE"] || "unknown")
	.toLowerCase()
	.replace(/\s+/g, "-")

export const Version =
	process.env["APP_VERSION"] || process.env["NEXT_PUBLIC_VERSION"] || "-"

export const Env =
	process.env["APP_ENV"] || process.env["NEXT_PUBLIC_ENVIRONMENT"] || "local"

export const Environment = capitalizeFirstLetter(
	Env === "dev" ? "development" : Env === "prod" ? "production" : Env,
	true,
)

export const SHA = (
	process.env["APP_SHA"] ||
	process.env["VERCEL_GIT_COMMIT_SHA"] ||
	process.env["NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA"] ||
	"-"
).slice(0, 7)

export const Built = process.env["APP_BUILT"] || "unknown"

export const Started =
	process.env["NEXT_PUBLIC_STARTED"] || new Date().toISOString()

export const ApiDomain = process.env["API_DOMAIN"]

export const isLocal = Env === "local"

export const isDev = Env === "dev"

export const isProd = Env === "prod"

export const isDebug =
	process.env["VITE_DEBUG_MODE"] || process.env["DEBUG_MODE"] === "true"
